import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { breakpoint } from '@zocdoc/components/src/grid';
import { Button } from '@zocdoc/components/src/button';
import { grey10 } from '@zocdoc/branding/colors';

import GreenBlob from './GreenBlob_HealthSystems.svg';
import LeftLogos from './health-systems-leftlogos-retina.png';
import RightLogos from './health-systems-rightlogos-retina.png';
import { Container, Headline, Paragraph } from '../Panel';

export class JoinPartnersView extends React.PureComponent {
    static propTypes = {
        trackJoinPartnersClick: PropTypes.func.isRequired,
    };

    render() {
        const {
            trackJoinPartnersClick,
        } = this.props;

        return (
            <PartnersPanelContainer>
                <PartnersPanelText>
                    <Headline>
                        <FormattedMessage
                            defaultMessage="Patients are losing patience when trying to access your care"
                            id="Home.Partners.LosingPatience"
                        />
                    </Headline>
                    <Paragraph>
                        <FormattedMessage
                            defaultMessage="See why we're the perfect partner for health systems."
                            id="Home.Partners.SeeWhy"
                        />
                    </Paragraph>
                    <JoinUsLink
                        beforeClick={trackJoinPartnersClick}
                        data-test="join-partners-button"
                        href="/about/healthsystems/"
                    >
                        <FormattedMessage
                            defaultMessage="Join us & our partners"
                            id="Home.Partners.JoinUs"
                        />
                    </JoinUsLink>
                </PartnersPanelText>

                <LeftLogoColumn />
                <RightLogoColumn />
            </PartnersPanelContainer>
        );
    }
}

const PartnersPanelContainer = styled(Container)`
    justify-content: center;

    background-color: ${grey10};
    background-size: auto 80%;
    background-repeat: no-repeat;

    ${breakpoint.small} {
        flex-wrap: wrap;
        padding-top: 84px;

        background-position: 70px 40px;
        background-image: url(${GreenBlob});
    }

    ${breakpoint.medium} {
        flex-wrap: nowrap;
        padding-top: 0;
        padding-bottom: 0;
        align-items: center;

        background-position: 100px 40px;
    }
`;

const PartnersPanelText = styled.div`
    ${breakpoint.small} {
        flex: 0 0 100%;
        text-align: center;
    }

    ${breakpoint.medium} {
        flex: 0 1 auto;
        text-align: left;
    }
`;

const JoinUsLink = styled(Button)`
    margin-top: 32px;
`;

const LogoColumn = styled.div`
    height: 370px;
    flex: 0 0 170px;

    background-position: center center;

    ${breakpoint.small} {
        margin: 60px 40px 0;
    }

    ${breakpoint.medium} {
        margin: 0 0 0 80px;
    }
`;

const LeftLogoColumn = styled(LogoColumn)`
    background-image: url(${LeftLogos});
    background-size: 167px 362px;
    background-repeat: no-repeat;
`;

const RightLogoColumn = styled(LogoColumn)`
    background-image: url(${RightLogos});
    background-size: 126px 366px;
    background-repeat: no-repeat;
`;
